var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "custom-navbar-history-list" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-row" }, [
        _c(
          "div",
          { staticClass: "search" },
          [
            _c("TextBox", {
              attrs: { placeholder: "搜索", linear: "" },
              model: {
                value: _vm.search,
                callback: function ($$v) {
                  _vm.search = $$v
                },
                expression: "search",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "operations" }, [
          _c(
            "div",
            { staticClass: "operation" },
            [
              _c(
                "VButton",
                {
                  attrs: { title: "刷新", round: "" },
                  on: {
                    click: function ($event) {
                      return _vm.reloadHistoryItems()
                    },
                  },
                },
                [_c("VIcon", { attrs: { icon: "mdi-refresh", size: 16 } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "operation", on: { click: _vm.toggleHistoryPause } },
            [
              !_vm.paused
                ? _c(
                    "VButton",
                    { attrs: { title: "暂停记录历史", round: "" } },
                    [_c("VIcon", { attrs: { icon: "mdi-pause", size: 14 } })],
                    1
                  )
                : _c(
                    "VButton",
                    { attrs: { title: "继续记录历史", round: "" } },
                    [_c("VIcon", { attrs: { icon: "mdi-play", size: 14 } })],
                    1
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "operation",
              attrs: {
                target: "_blank",
                href: "https://www.bilibili.com/history",
              },
            },
            [
              _c(
                "VButton",
                { attrs: { title: "查看更多", round: "" } },
                [
                  _c("VIcon", {
                    attrs: { icon: "mdi-dots-horizontal", size: 18 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-row" }, [
        _c("div", { staticClass: "row-title" }, [_vm._v("过滤:")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "type-filters" },
          _vm._l(_vm.types, function (t) {
            return _c(
              "div",
              { key: t.name, staticClass: "type-filter" },
              [
                _c(
                  "RadioButton",
                  {
                    class: { checked: t.checked },
                    attrs: { checked: t.checked, disabled: _vm.loading },
                    on: {
                      change: function ($event) {
                        return _vm.toggleTypeFilter(t)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(t.displayName) + "\n          "
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm.loading
          ? _c("VLoading")
          : !_vm.loading && _vm.groups.length === 0
          ? _c("VEmpty")
          : _c(
              "transition-group",
              { staticClass: "cards", attrs: { name: "cards", tag: "div" } },
              [
                _vm._l(_vm.groups, function (g) {
                  return _c(
                    "div",
                    { key: g.name, staticClass: "time-group" },
                    [
                      _c("div", { staticClass: "time-group-name" }, [
                        _vm._v("\n          " + _vm._s(g.name) + "\n        "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "transition-group",
                        {
                          staticClass: "time-group-items",
                          attrs: { name: "time-group", tag: "div" },
                        },
                        _vm._l(g.items, function (h) {
                          return _c(
                            "div",
                            { key: h.id, staticClass: "time-group-item" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "history-cover-container",
                                  attrs: { target: "_blank", href: h.url },
                                },
                                [
                                  _c("DpiImage", {
                                    staticClass: "cover",
                                    attrs: {
                                      src: h.cover,
                                      size: { width: 160, height: 110 },
                                      "placeholder-image": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  h.progress
                                    ? _c("div", {
                                        staticClass: "progress",
                                        style: {
                                          width: h.progress * 100 + "%",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  h.pages !== undefined && h.pages > 1
                                    ? _c(
                                        "div",
                                        { staticClass: "floating pages" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(h.page) +
                                              "P / " +
                                              _vm._s(h.pages) +
                                              "P\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "title",
                                  attrs: {
                                    target: "_blank",
                                    href: h.url,
                                    title: h.title,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(h.title || h.upName + "的直播间")
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "up",
                                  attrs: {
                                    target: "_blank",
                                    href:
                                      h.type === "pgc"
                                        ? h.url
                                        : "https://space.bilibili.com/" +
                                          h.upID,
                                    title: h.upName,
                                  },
                                },
                                [
                                  h.upFaceUrl
                                    ? _c("DpiImage", {
                                        staticClass: "up-face",
                                        attrs: { size: 18, src: h.upFaceUrl },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "up-name" }, [
                                    _vm._v(_vm._s(h.upName)),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "history-info" }, [
                                h.progressText
                                  ? _c(
                                      "div",
                                      { staticClass: "progress-number" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              h.progress >= 0.95
                                                ? "已看完"
                                                : h.progressText
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                h.liveStatus !== undefined
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "duration live-status",
                                        class: { on: h.liveStatus === 1 },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              h.liveStatus === 1
                                                ? "直播中"
                                                : "未开播"
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                h.progressText || h.liveStatus !== undefined
                                  ? _c(
                                      "span",
                                      { staticClass: "history-info-separator" },
                                      [_vm._v("|")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                h.timeText
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "time",
                                        attrs: {
                                          title: new Date(
                                            h.viewAt
                                          ).toLocaleString(),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(h.timeText) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.canNextPage
                  ? _c("ScrollTrigger", {
                      key: "scroll-trigger",
                      on: {
                        trigger: function ($event) {
                          return _vm.nextPage()
                        },
                      },
                    })
                  : _vm._e(),
              ],
              2
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }